import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const Wrapper = styled.div`
  padding: 1rem;
  font-size: 1rem;
`;
